import { useEffect, useRef } from "react";
import { useMobileDetection } from "../../hooks/use-mobile-detection";
import { FloatFooter } from "../navigation/FloatFooter";
export const Login = (props) => {
  const { isDesktop } = useMobileDetection();

  const starsRef = useRef(null);

  useEffect(() => {
    const canvas = starsRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    let W = 0;
    let H = 0;
    let stars = [];
    let animationId;

    const resize = () => {
      W = canvas.width = window.innerWidth;
      H = canvas.height = window.innerHeight;
    };

    const createStar = () => ({
      x: Math.random() * W,
      y: Math.random() * H,
      r: Math.random() * 1 + 0.2,
      a: Math.random(),
      da: (Math.random() * 0.005 + 0.001) * (Math.random() < 0.5 ? 1 : -1),
    });

    const init = () => {
      resize();
      stars = Array.from({ length: 160 }, createStar);
    };

    const draw = () => {
      ctx.clearRect(0, 0, W, H);

      for (const star of stars) {
        star.a += star.da;

        if (star.a <= 0.04 || star.a >= 1) {
          star.da *= -1;
        }

        ctx.beginPath();
        ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255,${star.a.toFixed(2)})`;
        ctx.fill();
      }

      animationId = requestAnimationFrame(draw);
    };

    window.addEventListener("resize", resize);

    init();
    draw();

    return () => {
      window.removeEventListener("resize", resize);
      cancelAnimationFrame(animationId);
    };
  }, []);

  return (
    <>
      <div className="min-h-full lg:flex">
        <canvas
          ref={starsRef}
          className="fixed inset-0 w-full h-full pointer-events-none"
        ></canvas>
        <div
          className="w-full"
          style={{
            backgroundColor: "#000000",
            height: "100dvh",
          }}
        >
          <div
            className="mx-auto h-full flex flex-col justify-center items-center"
            style={{
              maxWidth: !isDesktop && "28rem",
            }}
          >
            <div className="w-full px-4 flex justify-center">{props.form}</div>
            {!isDesktop && (
              <>
                <FloatFooter />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
